<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">OIL and OT Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row align-items-center">
      <div class="col-md-2">Company</div>
      <div class="col-md-4 p-0 fit-content">
        <select class="custom-select" v-model="company">
          <option
            v-for="(item, i) in companies"
            :key="i"
            :value="item.CompanyName"
          >
            {{ item.CompanyName }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center mt-2">
      <div class="col-md-2">Holiday Date</div>
      <div class="col-md-2 p-0 fit-content">
        <form id="oilForm" @submit.prevent="getOilReport">
          <input
            required
            type="date"
            class="form-control"
            v-model="holidayDate"
          />
        </form>
      </div>
      <div class="col-md-1 ml-md-5">
        <button type="submit" form="oilForm" class="btn btn-primary">
          Search
        </button>
      </div>

      <div class="col-md-3">
        <form
          :action="backendUrl + '/OilExcelReport/ExportExcel'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="company" />
          <input type="hidden" name="HolidayDate" :value="holidayDate" />
          <input type="hidden" name="Token" :value="token" />
          <button type="submit" class="btn btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Pagination -->
    <div class="row mt-4" v-if="records && records.length">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>
    <!-- /Result Empty -->

    <!-- Table List -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>Hire Date</th>
                <th>Termination Date</th>
                <th>Calendar</th>
                <th>1st Manager ID</th>
                <th>1st Manager Name</th>
                <th>1st Manager Email Address</th>
                <th>Designation</th>
                <th>Functional/Account Team</th>
                <th>Job Grade</th>
                <th>Ignite PH/PH in Lieu Date</th>
                <th>Ignite PH/PH in Lieu Day</th>
                <th>Ignite PH/PH in Lieu Credit</th>
                <th>Benefits Connect Work Status</th>
                <th>Benefits Connect Public Holiday</th>
                <th>Benefits Connect OT 1.50</th>
                <th>Benefits Connect OT 2.00</th>
                <th>Benefits Connect 12-hr Standby</th>
                <th>Benefits Connect 24-hr Standby</th>
                <th>Benefits Connect 12-hr Day Shift</th>
                <th>Benefits Connect 12-hr Night Shift</th>
                <th>Benefits Connect 8-hr Day Shift</th>
                <th>Benefits Connect 8-hr Night Shift</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in records" :key="item.Id">
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.HireDateDisplay }}</td>
                <td>{{ item.TerminationDateDisplay }}</td>
                <td>{{ item.Calendar }}</td>
                <td>{{ item.FirstManagerID }}</td>
                <td>{{ item.FirstManagerName }}</td>
                <td>{{ item.FirstManagerEmail }}</td>
                <td>{{ item.Designation }}</td>
                <td>{{ item.Functional }}</td>
                <td>{{ item.JobGrade }}</td>
                <td>{{ item.PhInLieuDateDisplay }}</td>
                <td>{{ item.PhInLieuDay }}</td>
                <td>{{ item.PhInLieuCredit }}</td>
                <td>{{ item.WorkStatus }}</td>
                <td>{{ item.PublicHoliday }}</td>
                <td>{{ item.Ot15 }}</td>
                <td>{{ item.Ot20 }}</td>
                <td>{{ item.Standby12Hr }}</td>
                <td>{{ item.Standby24Hr }}</td>
                <td>{{ item.DayShift12Hr }}</td>
                <td>{{ item.NightShift12Hr }}</td>
                <td>{{ item.DayShift8Hr }}</td>
                <td>{{ item.NightShift8Hr }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      defaultCompany: config.DEFAULT_COMPANY,
      companies: [],
      company: "",
      holidayDate: "",
      records: [],
      //paging
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },
  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getOilReport();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    //filter
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            if (
              this.companies.find(
                (c) => c.CompanyName == this.defaultCompany
              ) == null
            ) {
              this.companies.push({ CompanyName: this.defaultCompany });
            }
            this.company = this.defaultCompany;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //main function
    getOilReport() {
      let param = {
        Token: this.token,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        Company: this.company,
        HolidayDate: this.holidayDate,
      };
      this.$store.state.isLoading = true;
      API.getOilReport(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getOilReport();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getOilReport();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getOilReport();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getOilReport();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getOilReport();
    },
  },
  created() {
    this.getCompanies();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/OILAndOTReport/OILAndOTReport.vue